import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withComponentInputBinding, withHashLocation } from "@angular/router";
import { provideHttpClient } from "@angular/common/http";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        // Hash routing so the static host needs no rewrite rules (links look like /#/assess/{token}).
        provideRouter(routes, withHashLocation(), withComponentInputBinding()),
        provideHttpClient(),
    ],
};
